import { useApolloClient } from '@apollo/client';
import { FormControl, FormLabel, Grid } from '@mui/material';
import ArticleTypeLogo from 'app/components/RichList/items/ArticleItem/components/ArticleTypeLogo';
import { useFormikContext } from 'formik';

import { translations } from 'locales/i18n';
import { useTranslation } from 'react-i18next';
import { ACLHelper } from 'utils/ACLHelper';
import CategoryCard from './CategoryCard';

import USER_QUERY from 'gql/queries/currentUser.gql';

export default function ArticleType() {
  const { values, setFieldValue, errors, validateForm }: any = useFormikContext();
  const { t } = useTranslation();
  const client = useApolloClient();
  const userData = client.readQuery({ query: USER_QUERY });
  const aclHelper = new ACLHelper(userData.currentUser);

  return (
    <Grid container>
      <Grid container>
        <FormControl className="articleModal__body__input" required error={errors.type}>
          <FormLabel className="articleModal__body__input__label">
            {t(translations.pages.articles.create.general.selectCategory())}
          </FormLabel>
          <Grid
            container
            spacing={4}
            justifyContent="center"
            className="articleModal__body__categories"
          >
            <Grid
              item
              xs={12}
              md
              onClick={async () => {
                await Promise.all([
                  setFieldValue('type', 'general', false),
                  setFieldValue('appointment.allDay', false, false),
                  setFieldValue('withAppointment', false, false)
                ]);
                await validateForm();
              }}
            >
              <CategoryCard
                icon={<ArticleTypeLogo articleType="general" />}
                headline={t(translations.pages.articles.create.general.general())}
                description={t(translations.pages.articles.create.general.generalDescription())}
                active={values.type === 'general'}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md
              onClick={async () => {
                await Promise.all([
                  setFieldValue('type', 'study'),
                  setFieldValue('appointment.allDay', false),
                  setFieldValue('withAppointment', false)
                ]);
                await validateForm();
              }}
            >
              <CategoryCard
                icon={<ArticleTypeLogo articleType="study" />}
                headline={t(translations.pages.articles.create.general.study())}
                description={t(translations.pages.articles.create.general.studyDescription())}
                active={values.type === 'study'}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md
              onClick={async () => {
                await Promise.all([
                  setFieldValue('type', 'event', false),
                  setFieldValue('appointment.allDay', false, false),
                  setFieldValue('withAppointment', true, false)
                ]);
                await validateForm();
              }}
            >
              <CategoryCard
                icon={<ArticleTypeLogo articleType="event" />}
                headline={t(translations.pages.articles.create.general.event())}
                description={t(translations.pages.articles.create.general.eventDescription())}
                active={values.type === 'event'}
              />
            </Grid>
            {aclHelper.isSuperUser() && (
              <>
                <Grid
                  item
                  xs={12}
                  md
                  onClick={async () => {
                    await Promise.all([
                      setFieldValue('type', 'legal'),
                      setFieldValue('appointment.allDay', false),
                      setFieldValue('withAppointment', true)
                    ]);
                    await validateForm();
                  }}
                >
                  <CategoryCard
                    icon={<ArticleTypeLogo articleType="legal" />}
                    headline={t(translations.pages.articles.create.general.legal())}
                    description={t(translations.pages.articles.create.general.legalDescription())}
                    active={values.type === 'legal'}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md
                  onClick={async () => {
                    await Promise.all([
                      setFieldValue('type', 'holiday'),
                      setFieldValue('appointment.allDay', true),
                      setFieldValue('withAppointment', true)
                    ]);
                    await validateForm();
                  }}
                >
                  <CategoryCard
                    icon={<ArticleTypeLogo articleType="holiday" />}
                    headline={t(translations.pages.articles.create.general.holiday())}
                    description={t(translations.pages.articles.create.general.holidayDescription())}
                    active={values.type === 'holiday'}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </FormControl>
      </Grid>
    </Grid>
  );
}
